/**
 * Created by Daniel on 07/15/2020.
 * Description:
 *
 * ------ maintenance history ------
 */
import { Subject } from 'rxjs';

export class TaskMenuConfig {
    selectedItemIndex: number;
    menuTextContainer: ['', ''];

    actionSubject$: Subject<any>;
    feedbackSubject$: Subject<any>;

    constructor(selectedIndex, menuText) {
        this.selectedItemIndex = selectedIndex;
        this.menuTextContainer = menuText;

        this.actionSubject$ = new Subject();
        this.feedbackSubject$ = new Subject();
    }
}




